const common = {
    'common.sure': 'Bestätigen',
    'common.save': 'Speichern',
    'common.cancel': 'Abbrechen',
    'common.loading': 'Wird geladen...',
    'common.loading.noMore': 'Nicht mehr~',
    'common.loading.loading1': 'Wird geladen',
    'common.success': 'gelungen',
    'common.fail': 'ungelungen',
    'common.unKnowError': 'Unbekannte Anomalie',
    'common.unitDayOdd': 'tag',
    'common.unitDayPlural': 'tage',
    'common.unitMonthOdd': 'monat',
    'common.unitMonthPlural': 'monate',
    'common.infiniteAct': 'Einst unbegrenzt !',
    'common.label': 'Promotion kommt',
    'common.404': 'Hoppla. Die von Ihnen angeforderte Seite wurde nicht gefunden!'
}
const language = {
    'lang.chinese': 'Chinesisch',
    'lang.english': 'Englisch',
    'lang.germany': 'Deutsch',
    'lang.spanish': 'Spanisch',
    'lang.french': 'Französisch',
    'lang.italian': 'Italienisch',
    'lang.portuguese': 'Portugiesisch',
}
// 登录页
const login = {
    'login.loginText': 'Anmelden',
    'login.input.email': 'E-Mail Adresse(LenovoID)',
    'login.input.password': 'Passwort',
    'login.tip.noAccount': 'Noch kein Konto?',
    'login.tip.toRegister': 'zum Anmelden',
    'login.tip.forget': 'Passwort vergessen?',
    'login.check.noInfo': 'Falsche Email oder Passwort.',
    'login.failed': 'Anmelden fehlgeschlagen',
    'login.terms': 'Bitte lesen Sie die Allgemeinen Geschäftsbedingungen',
    'login.banner.flow': 'Registrieren Sie sich jetzt und genießen Sie 1GB*6 Monate kostenlose Daten',
    'login.banner.VFflow': 'Registrieren Sie sich jetzt und genießen Sie 5GB*3 Monate kostenlose Daten',
    'login.banner.coming': 'Promotion kommt:',
    'login.banner.size': 'Der erste Monat explodiert auf unbegrenzte Daten'
}
// 注册页面
const register = {
    'register.registerText': 'Anmelden',
    'register.input.firstName': 'First Name',
    'register.check.noFirstNameField': 'Please input First Name',
    'register.input.lastName': 'Last Name',
    'register.check.noLastNameField': 'Please input Last Name',
    'register.input.email': 'E-Mail Adresse',
    'register.input.imgCode': 'Bildcaptcha',
    'register.input.verifyCode': 'Captcha',
    'register.input.password': 'Passwort',
    'register.input.rePassword': 'Passwort wiederholen',
    'register.input.alRegister': 'Bereits angemeldet',
    'register.input.toLogin': 'Anmelden',
    'register.input.termsOfService': 'Nutzungsbedingungen',
    'register.input.privacyStatement': 'Datenschutzerklärung',
    'register.tip': 'Durch die Erstellung eines Kontos stimmen Sie den {termsOfService} und der {privacyStatement} zu.',
    'register.tipForTablet': 'Mit der Erstellung des Kontos haben Sie die <a1>Preload Data Plan Beschreibungen</a1>, <a2>Geschäftsbedingungen</a2> von Lenovo Connect, Die Allgemeinen <a3>Geschäftsbedingungen</a3> von HUE, <a4>Datenschutzrichtlinie</a4> von Lenovo Connect, and <a5>Datenschutzrichtlinie</a5> von HUE.',
    'register.sendMsg.text': 'Captcha erhalten',
    'register.sendMsg.reSend': 'Erneut senden',
    'register.sendMsg.sendSuccess': 'Die E-Mail wurde verschickt',
    'register.sendMsg.sendFailed': 'E-Mail fehlgeschlagen',
    'register.check.noEmailField': 'Bitte geben Sie eine E-Mail ein',
    'register.check.noImageCodeField': 'Bitte geben Sie Bild-Captcha ein',
    'register.check.noVerifyField': 'Bitte geben Sie das Captcha ein, das Sie erhalten haben',
    'register.check.noPasswdField': 'Bitte geben Sie Passwort ein',
    'register.check.noConfirmPasswd': 'Bitte bestätigen Sie Passwort',
    'register.check.errorEmail': 'Falsches E-Mail',
    'register.check.errorImageCode': 'Falsches Bild-Captcha',
    'register.check.errorVerifyCode': 'Falsches Captcha',
    'register.check.errorPasswd': 'Falsches passwort',
    'register.check.errorTwoPasswd': 'Die beiden eingegebenen Passwörter stimmen nicht überein',
    'register.success': 'erfolgreich angemeldet',
}
// 首页
const home = {
    'home.header.upload': 'Hochladen',
    'home.header.iccid': 'iccid-Code',
    'home.flowUse.title': 'aktuelles Paket',
    'home.flowUse.status.title': 'Nutzungsstatus',
    'home.flowUse.status.used': 'verbraucht',
    'home.flowUse.status.remaining': 'verbleibend',
    'home.flowUse.dataPlan.key': 'Paketname',
    'home.flowUse.validity.key': 'Gültigkeit',
    'home.flowUse.note.key': 'Anmerkung',
    'home.flowUse.note': 'Anmerkung',
    'home.flowUse.leftDay': 'verbleibend {day}{unit}',
    'home.flowUse.currentDataPlan.title': 'Mein Datenpaket',
    'home.flowUse.currentDataPlan.titleHue': 'Mein Konnektivitäts-Servicepaket',
    'home.flowUse.outDate': 'Datenpaket ist abgelaufen',
    'home.flowUse.lock': 'SIM-Karte ist gesperrt',
    'home.flowUse.noDataPlan': 'kein Datenpaket verwendet',
    'home.flowUse.status.unlimited': 'Unbegrenzt',
    'home.area.intro.title': 'Datenmenge Prepaid',
    'home.area.intro.titleHue': 'Prepaid',
    'home.area.intro.content': 'Unsere Pakete können alle <cta>EU-Länder abdecken</cta> (Österreich, Belgien, Bulgarien, Kroatien, Zypern, Tschechische Republik, Dänemark, Estland, Finnland, Frankreich, Deutschland, Gibraltar, Griechenland, Ungarn, Irland, Italien, Lettland, Litauen, Luxemburg, Malta, Niederlande, Polen, Portugal, Rumänien, Slowakische Republik, Slowenien, Spanien, Schweden),<cta> sowie Island, Norwegen, Schweiz, Vereinigtes Königreich und Vereinigte Staaten von Amerika,</cta>',
    'home.area.intro.contentHUE': 'Unsere Pakete können alle <cta>EU-Länder abdecken</cta> (Österreich, Belgien, Bulgarien, Kroatien, Zypern, Tschechische Republik, Dänemark, Estland, Finnland, Frankreich, Deutschland, Gibraltar, Griechenland, Ungarn, Irland, Italien, Lettland, Litauen, Luxemburg, Malta, Niederlande, Polen, Portugal, Rumänien, Slowakische Republik, Slowenien, Spanien, Schweden),<cta> sowie Island, Norwegen, Schweiz, Vereinigtes Königreich,</cta>Bitte aktivieren Sie sowohl mobile Daten als auch Roaming (keine zusätzliche Roaming-Gebühr).',
    'home.area.intro.vatIntro': 'Die unten aufgeführten Preise sind inklusive Mehrwertsteuer.',
    'home.area.intro.suggest': 'Empfehlen',
    'home.area.switch.title': 'Region:',
    'home.active.title': 'Mein Datenpaket aktivieren',
    'home.active.intro': 'Der "{packageContent}"-Prepaid-Datenpaket muss innerhalb von 90 Tagen nach dem Einschalten des Geräts aktiviert werden. Unmittelbar nach der Erstaktivierung bleiben {timeLength} Validität',
    'home.active.agree': 'Wenn Sie es aktivieren, stimmen Sie dem zu <a>Preload-Datenpaket gelesen und akzeptiert</a>, <a1>Terms and Conditions</a1> and <a2>Datenschutzrichtlicnien</a2>. Lenovo Connect unterstützt von Truphone.',
    'home.active.agreeForTablet': 'Wenn Sie es aktivieren, stimmen Sie dem zu <a>Preload-Datenpaket gelesen und akzeptiert</a>, <a1>Terms and Conditions</a1> and <a2>Datenschutzrichtlicnien</a2>.',
    'home.active.btnText': 'Jetzt aktivieren',
    'home.active.failed': 'Aktivierung fehlgeschlagen !',
    'home.active.success': 'erfolgreich aktiviert',
    'home.active.success.btn': 'bekannt',
    'home.active.detail.title': 'Preload-Datenpaket gelesen und akzeptiert',
    'home.active.detail.faq': 'Wenn Sie Fragen haben, wenden Sie sich bitte an den <a>Kundendienst</a>',
}
// 我的页面
const me = {
    'me.signOut': 'Abmelden',
    'me.nav.device': 'Mein Gerät',
    'me.nav.package': 'Mein Datenpaket',
    'me.nav.order': 'Mein Auftrag',
    'me.nav.accountInfo': 'Mein Konto',
    'me.nav.FAQ': 'FAQ',
    'me.nav.contactUs': 'Kontaktieren Sie uns',
    'me.signOut.alert.title': 'Abmelden',
    'me.signOut.alert.content': 'Sind Sie sicher, dass Sie sich abmelden wollen?'
}
const suggest = {
    'suggest.title': 'Vorschlagsbox',
    'suggest.toast': 'Bitte Inhalt eingeben',
    'suggest.success': 'gelungen',
    'suggest.suggestions': 'Bitte teilen Sie uns Ihre Anregungen oder Fragen mit',
    'suggest.submit': 'Einreichen',
    'suggest.information': 'Information',
    'suggest.submission': 'Meine Einsendung',
    'suggest.noMore': 'Keine Daten mehr',
    'suggest.uploadImg': 'Bildgröße darf 5M nicht überschreiten',
}
// 账号信息
const accountInfo = {
    'account.errorNickname': 'Spitzname sollte 4-20 Zeichen sein',
    'account.account.fieldTitle': 'Konto',
    'account.nickName.fieldTitle': 'Benutzername',
    'account.nickName.character': '4-20 Zeichen einschließlich Chinesisch und Englisch, Zahlen oder „-“. ',
}
// 套餐卡片
const packageCard = {
    'package.validDate': 'Gültigkeit für {timeLength}{dateUnit}',
    'package.validTo': 'gültig bis {date} UTC',
    'package.orderBtnText': 'Bestellen Sie jetzt',
    'package.extend.title': 'Erweitern Sie Mein Datenpaket',
    'package.expand.title': 'Erweitern Sie Mein Datenpaket',
    'package.extend.titleHue': 'Abonnieren Sie jetzt Ihr monatliches Datenpaket',
    'package.expand.titleHue': 'Fügen Sie ein zusätzliches Konnektivitätsdienstpaket hinzu',
    'package.expand.add': 'Hinzufügen',
}
// 套餐详情
const packageDetail = {
    'packageDetail.privacy': 'Ja, ich habe die gelesen und akzeptiert <a>Terms and Conditions</a> und <b>Datenschutzrichtlicnien</b>.',
    'packageDetail.privacyForTablet': 'Ja, ich habe die gelesen und akzeptiert <a>Terms and Conditions</a> und <b>Datenschutzrichtlicnien</b>.',
    'packageDetail.description': 'Beschreibung',
    'packageDetail.expansionPackage.title': 'Erweitern Sie den aktuellen Datenpaket',
    'packageDetail.payBtn.text': 'Zahlen Sie jetzt',
}
// 地址
const billAddress = {
    'billAddress.history.title': 'Historische Rechnungsadresse',
    'billAddress.fieldWrap.title': 'Geben Sie Ihre Rechnungsadresse ein',
    'billAddress.btn.continue': 'Fortsetzen',
    'billAddress.btn.cancel': 'Abbrechen',
    'billAddress.field.firstName': 'Vorname',
    'billAddress.field.lastName': 'Nachname',
    'billAddress.field.email': 'E-Mail',
    'billAddress.field.street': 'Straße',
    'billAddress.tips.payment': 'Wie bezahlen Sie?',
    'billAddress.tips.newCard': 'neue Karte',
    'billAddress.tips.oldCard': 'alte Karte',
    'billAddress.field.city': 'Stadt',
    'billAddress.field.state': 'Staat',
    'billAddress.field.postCode': 'Postleitzahl',
    'billAddress.field.country': 'Land',
    'billAddress.field.firstNameError': 'Vorname ist ein Pflichtfeld',
    'billAddress.field.lastNameError': 'Nachname ist ein Pflichtfeld',
    'billAddress.field.emailError': 'E-Mail ist ein Pflichtfeld',
    'billAddress.field.emailFormatError': 'Geben Sie eine gültige E-Mail-Adresse ein',
    'billAddress.field.streetError': 'Straße ist ein Pflichtfeld',
    'billAddress.field.cityError': 'Stadt ist ein Pflichtfeld',
    'billAddress.field.stateError': 'Staat ist ein Pflichtfeld',
    'billAddress.field.postCodeError': 'Postleitzahl ist ein Pflichtfeld',
    'billAddress.field.countryError': 'Land ist ein Pflichtfeld',
}
// 订单
const order = {
    'order.subType.1': 'aktivieren',
    'order.subType.2': 'abonnieren',
    'order.subType.4': 'einlösen',
    'order.subType.5': 'Geschenk',
    'order.subType.6': 'Unternehmen abonnieren',
    'order.subType.7': 'erlebnispaket',
    'order.subType.8': 'Update',
    'order.subType.9': 'Zusatzpaket',
    'order.subType.systemOrder': 'System bestellt',
    'order.item.orderNum': 'Auftragsnummer',
    'order.item.content': 'Inhalt',
    'order.item.orderType': 'Auftragsart',
    'order.item.validity': 'Gültigkeit',
    'order.item.subTotal': 'Zwischensumme',
    'order.item.vat': 'Mehrwertsteuer',
    'order.item.totalFee': 'Summe',
    'order.noInfo.message': 'Sie haben noch kein Pakete bestellt.',
    'order.noInfo.btnText': 'Zur Startseite'
}
// 支付结果页
const payResult = {
    'pay.success': 'Zahlung erfolgreich',
    'pay.fail': 'Zahlung fehlgeschlagen',
    'pay.checkOrder': 'Bestellung ansehen',
    'pay.back': 'Zurück',
    'pay.continue': 'Weiter zur Bestellung',
}
// 我的设备页面
const device = {
    'device.switch': 'Gerät wechseln',
    'device.status.current': 'Aktuelles Gerät',
    'device.status.available': 'Verfügbares Gerät',
    'device.switch.alert.title': 'Aufforderung',
    'device.switch.alert.content': 'Sind Sie sicher, zu diesem Gerät zu wechseln?',
    'device.noInfo.message': 'Sie haben das Gerät noch nicht gebunden',
    'device.noInfo.btnText': 'Zum Binden mit dem Gerät',
    'device.edit.prompt.message': 'Bitte geben Sie einen Spitznamen ein',
    'device.edit.check.none': 'Spitzname ist ein Pflichtfeld'
}
// 我的套餐
const myDataPlan = {
    'myDataPlan.tabbar.available': 'Verfügbares Datenpaket',
    'myDataPlan.tabbar.expired': 'Abgelaufenes Datenpaket',
    'myDataPlan.noAvailablePlan': 'kein Datenpaket verfügbar',
    'myDataPlan.noExpiredPlan': 'Kein abgelaufenes Datenpaket',
}
// 联系我们
const Contact = {
    'contact.chooseRegion.text': 'Wählen Sie Ihre Region',
    'contact.country.AT': 'Österreich',
    'contact.country.BE': 'Belgien',
    'contact.country.DK': 'Dänemark',
    'contact.country.FI': 'Finnland',
    'contact.country.FR': 'Frankreich',
    'contact.country.DE': 'Deutschland',
    'contact.country.IE': 'Irland',
    'contact.country.IT': 'Italien',
    'contact.country.LUX': 'Luxemburg',
    'contact.country.NL': 'Niederlande',
    'contact.country.NO': 'Norwegen',
    'contact.country.PT': 'Portugal',
    'contact.country.ES': 'Spanien',
    'contact.country.SE': 'Schweden',
    'contact.country.CH': 'Schweiz',
    'contact.country.UK': 'Vereinigtes Königreich',
    'contact.country.USA': 'USA',

    'contact.phone.AT': '(+43) (0)1 9287 666',
    'contact.phone.BE': '02-700-73-77 (lokaler Satz)',
    'contact.phone.DK': '+45 89881536',
    'contact.phone.FI': '+358 97 47 90 251',
    'contact.phone.FR': '+ 33 170 381 927',
    'contact.phone.DE': '(+49) (0)201 22099 888',
    'contact.phone.IE': '1-890-928-860 (Anrufe unter dieser Nummer aus dem Festnetz werden zum lokalen Satz berechnet und haben einen Mindestpreis von €0,05. Anrufe von Mobiltelefonen können variieren.)',
    'contact.phone.IT': '(+39)02 303 10000',
    'contact.phone.LUX': '+352 2487 16 11',
    'contact.phone.NL': '+31 204 990 153',
    'contact.phone.NO': '+47 67 204501',
    'contact.phone.PT': '+351 211 227 833',
    'contact.phone.ES': '+34 9179 11 799',
    'contact.phone.SE': '+46 840 30 01 81',
    'contact.phone.CH': '+41 44 798 2222',
    'contact.phone.UK': '+44 333-777-3991 (Nationaler Satz)',
    'contact.phone.USA': '1-800-426-7378, #1',

    'contact.workHours.AT': '9:00 - 18:00 Montag - Freitag',
    'contact.workHours.BE': '9:00 - 18:00 Montag - Freitag',
    'contact.workHours.DK': '9:00 - 18:00 Montag - Freitag',
    'contact.workHours.FI': '9:00 - 18:00 Montag - Freitag',
    'contact.workHours.FR': '09:00 - 18:00 Lundi - Vendredi',
    'contact.workHours.DE': '8 - 18 Uhr Montag - Freitag',
    'contact.workHours.IE': '09:00 - 18:00 Montag - Freitag',
    'contact.workHours.IT': '09:00 - 18:00 Montag - Freitag',
    'contact.workHours.LUX': '09:00 - 18:00 Montag - Freitag',
    'contact.workHours.NL': '09:00 - 18:00 Montag - Freitag',
    'contact.workHours.NO': '09:00 - 18:00 Montag - Freitag',
    'contact.workHours.PT': '09:00 - 18:00 Montag - Freitag',
    'contact.workHours.ES': 'von 8:00h bis 18:00h, Montag bis Freitag',
    'contact.workHours.SE': '09:00 - 18:00 Montag - Freitag',
    'contact.workHours.CH': '9:00 - 18:00 Montag - Freitag',
    'contact.workHours.UK': '09:00 - 18:00 Montag - Freitag',
    'contact.workHours.USA': '00:00 - 24:00 Montag - Sonntag',
}
// 绑卡页面
const bindSim = {
    'bindSim.hello': 'Hallo',
    'bindSim.activate.title': 'Aktivieren Sie Ihr Datenpaket',
    'bindSim.tip.text1': 'Laden Sie ein Barcode-Bild hoch, um die SIM-Karte zu binden',
    'bindSim.tip.text2': 'Aktivieren Sie das Datenpaket und verwenden Sie',
    'bindSim.btn.text': 'Bild hochladen',
}
// FAQ页面
const FAQ = {
    'faq.question.1': 'Kann ich anrufen oder SMS senden?',
    'faq.question.2': 'Wie kann ich einen Datenpaket kaufen und meinen Bestelldatensatz überprüfen?',
    'faq.question.3': 'Was sind die Regeln der Bestelldaten?',
    'faq.question.4': 'Welche Zahlungsmethoden kann ich benutzen?',
    'faq.question.5': 'Wie kann ich mein Datenpaket ausschalten, wenn ich ihn nicht verwenden möchte?',
    'faq.question.6': 'Ich habe ein Datenpaket erfolgreich bestellt, warum kann ich ihn nicht verwenden?',
    'faq.question.7': 'Was passiert, wenn ich keinen Internetzugang bekomme?',
    'faq.question.8': 'Welche Länder kann das Datenpaket abdecken?',
    'faq.question.9': 'Wie erreiche ich den Lenovo Kundenservice?',
    'faq.question.10': 'Wie kann ich eine Quittung für meine Bestellung anfordern?',
    'faq.question.11': 'Wie ersetzt man eine SIM-Karte?',
    'faq.question.12': 'Ist es kostenlos, eine SIM zu ersetzen?',
    'faq.question.13': 'Kann ich das aktivierte Datenpaket anhalten, wenn meine SIM kaputt, verloren oder fehlerhaft ist?',
    'faq.question.14': 'Was passiert, wenn ich mein Passwort vergessen habe?',
    'faq.question.15': 'Kann ich Änderungen vornehmen, nachdem die ICCID meiner SIM-Karte mit meiner Lenovo ID gebunden sind?',
    'faq.question.16': 'Was soll ich tun, wenn das Gerät mich auffordert, PIN, PIN 2 oder PUK-Code oder APN einzugeben?',
    'faq.question.17': 'Wie überprüfe ich die ICCID meiner SIM?',
    'faq.question.18': 'Kontaktiere uns',
    'faq.answer.1': 'SIM unterstützt nur Daten für den Netzwerkzugang. Sie erhalten keine Handynummer. Sie können immer noch mit Apps wie Skype und WhatsApp anrufen oder SMS senden.',
    'faq.answer.2': 'Bitte besuchen Sie aoacwap.lenovoconnect.com für den Prozess.',
    'faq.answer.3': 'Erfolgreich bestelltes Datenpakete wird automatisch aktiviert (z.B. Mein Datenpaket erweitern) oder in der Warteschlange warten, um aktiviert zu werden (z.B. Mein Datenpaket erweitern). Wir unterstützen keine Rückerstattung oder Aussetzung des Datenpakets. ',
    'faq.answer.4': 'Wir verkaufen Datenpakete in GBP, EUR, USD, CHF, NOK, DKK, SEK und unterstützen Kredit-/Debit Visa oder Master-Karten.',
    'faq.answer.5': 'Wenn Sie die Mobilfunkverbindung nicht mehr benutzen möchten, klicken Sie bitte auf OFF the Mobile data. Bitte beachten Sie, dass Ihr laufendes Datenpaket NICHT ausgesetzt oder zurückerstattet wird. ',
    'faq.answer.6.1': '1) Wenn der Bestellplan Ihren aktuellen Plan erweitern wird, kann er erst aktiviert werden, wenn Ihr aktueller Plan abläuft. ',
    'faq.answer.6.2': '2) Wenn das bestellte Datenpaket Ihr aktuelles Datenpaket erweitern wird, sollte er automatisch aktiviert werden. Bitte lesen Sie andere FAQ zu Verbindungsproblemen, oder wenden Sie sich an Lenovo.com Kundenservice in Ihrem eigenen Land.',
    'faq.answer.6.3': '3) Wenn Sie mehrere Geräte unter der gleichen Lenovo ID haben, stellen Sie bitte sicher, dass das bestellte Datenpaket unter der ICCID der SIM des aktuellen verwendeten Geräts ist.',
    'faq.answer.7.1': '1) Überprüfen Sie, ob Mobiledaten eingeschaltet wird.',
    'faq.answer.7.2': '2) Überprüfen Sie, ob Daten-Roaming aktiviert ist. (Stellen Sie fest, ob es in Europa zu aktivieren ist, da gemäß der Anweisung des Laptops es zu aktivieren ist) Gehen Sie zu Settings->Network&Internet->Mobile network->Data roaming',
    'faq.answer.7.3': '3) Überprüfen Sie, ob Access Point Name (APN) korrekt eingestellt ist. (Schreiben Sie APN auf) Settings->Network&Internet->Mobile network->Advanced->Access point names->See if the below APN has been correctly set up.  If not,add APN: net.truphone.com',
    'faq.answer.7.4': '4) Wenn dies Ihre erste Verbindung ist, kann es einige Minuten für die SIM-Verbindung dauern.',
    'faq.answer.7.5': '5) Bitte stellen Sie sicher, dass der Preload-Datenpaket aktiviert ist; wenn nicht, folgen Sie bitte den Anweisungen im SIM-Paket, um es zu aktivieren.',
    'faq.answer.7.6': '6) Stellen Sie sicher, dass Ihr aktueller Standort innerhalb unseres Service-Abdeckungsumfangs liegt (siehen Sie die vollständige Liste der abgedeckten Länder unten). Bringen Sie Ihr Gerät neben ein Fenster oder in einen offenen Bereich, um ein besseres Signal zu erhalten. ',
    'faq.answer.8': 'Das Datenpaket deckt alle EU-Länder ab (Österreich, Belgien, Bulgarien, Kroatien, Zypern, Tschechische Republik, Dänemark, Estland, Finnland, Frankreich, Deutschland, Griechenland, Ungarn, Irland, Italien, Lettland, Litauen, Luxemburg, Malta, Niederlande, Polen, Portugal, Rumänien, Slowakische Republik, Slowenien, Spanien, Schweden) sowie Island, Norwegen, die Schweiz, das Vereinigte Königreich und die Vereinigten Staaten von Amerika.',
    'faq.answer.8.1': 'Der Datenpaket deckt alle EU-Länder ab (Österreich, Belgien, Bulgarien, Kroatien, Zypern, Tschechische Republik, Dänemark, Estland, Finnland, Frankreich, Deutschland, Griechenland, Ungarn, Irland, Italien, Lettland, Litauen, Luxemburg, Malta, Niederlande, Polen, Portugal, Rumänien, Slowakische Republik, Slowenien, Spanien, Schweden) sowie Island, Norwegen, die Schweiz, das Vereinigte Königreich.',
    'faq.answer.9': 'Bitte lesen Sie Contact us informationen zu Lenovo.com in Ihrem eigenen Land.',
    'faq.answer.10': 'Die Quittung wird nach erfolgreicher Bestellung automatisch an Ihre angemeldete E-Mail-Adresse gesendet. Bitte überprüfen Sie sowohl Ihren inbox als auch den junk mail box dafür. Falls sie immer noch nicht erhalten sind, wenden Sie sich bitte an den Lenovo Kundenservice.',
    'faq.answer.11': 'Falls Ihre SIM kaputt, verloren oder fehlerhaft ist, wenden Sie sich bitte an den Lenovo Kundenservice, um eine Lösung zu finden.',
    'faq.answer.12': 'Ja, aber es kann Kurierdienstgebühren entstehen. Für weitere Details wenden Sie sich bitte an den Lenovo Kundenservice.',
    'faq.answer.13': 'Es tut mir Leid, dass das Datenpaket leider nicht angehalten werden kann.',
    'faq.answer.14': 'Sie können Ihr Passwort über Forgot password auf der Anmeldeseite erneut einstellen.',
    'faq.answer.15': 'Ja. Bitte wenden Sie sich für eine solche Anforderung an den Lenovo Kundenservice. Nach der Überprüfung werden die Kundenservicemitarbeiter dabei helfen, die aktuelle Bindung zwischen der ICCID der SIM und Ihrer Lenovo ID zu entfernen. Beachten Sie, dass das Datenpakete innerhalb der Gültigkeitsdaten nicht ausgesetzt oder zurückerstattet werden können, wie auch der Bindungsstatus der SIM-Lenovo ID ist.',
    'faq.answer.16': 'Versuchen Sie, Mobile Daten zu deaktivieren und zu reaktivieren und das Gerät ebenfalls erneut zu starten. Wenn dies nicht wirkt, wenden Sie sich bitte an unseren Kundenservice. ',
    'faq.answer.17.1': '1) Sie finden die ICCID auf dem SIM-Chip oder dem SIM-Halter.',
    'faq.answer.17.2': '2) Wenn Sie SIM schon aktiviert und das Datenpaket vorgeladen haben, besuchen Sie bitte aoacwap.lenovoconnect.com und überprüfen Sie Me->Device',
    'faq.answer.18': 'Bitte lesen Sie Contact us informationen zu Lenovo.com in Ihrem eigenen Land.',
}
//平板faq
const faqApp = {
    'faq.title.1': 'FAQ-About Lenovo Connect',
    'faq.question.1': 'F1: Wie kann ich den Kundendienst kontaktieren, wenn keine der folgenden Fragen beantwortet werden kann?',
    'faq.answer.1': 'A1: Bitte wenden Sie sich an die offizielle Website für Kundendienst oder mailen Sie direkt an service@lenovoconnect.com. Bitte geben Sie die ICCID der Karte in der E-Mail an.',
    'faq.question.2': 'F2: Unterstützt die SIM-Karte Anrufe und SMS?',
    'faq.answer.2': 'A2: Die SIM-Karte unterstützt nur die Datenverkehr-Internetfunktion, keine Sprach- und SMS-Funktionen.',
    'faq.question.3': 'F3: Kann die Karte auf andere Geräte umgestellt werden?',
    'faq.answer.3': 'A3: Es unterstützt nur die Anwendung in das aktuelle Gerät (Tablet) und andere Geräte werden vorübergehend nicht unterstützt.',
    'faq.question.4': 'F4: In welchen Ländern wird das Datenpaket verwendet? Haben verschiedene Länder Roaming-Gebühren?',
    'faq.answer.4': 'A4: Das Datenpaket kann in Ländern einschließlich aller EU-Länder und Island, Norwegen, der Schweiz und dem Vereinigten Königreich verwendet werden. In diesen Ländern fallen keine zusätzlichen Roaming-Gebühren an.',
    'faq.title.2': 'FAQ-About Connectivity Service Package',
    'faq.question.5': 'F1: Wie bestelle ich ein Datenpaket und überprüfe den Bestelldatensatz? Kann der Datenpaketverkehr bis zum nächsten Monat akkumuliert werden, wenn er nicht aufgebraucht ist?',
    'faq.answer.5': 'A1: Bitte besuchen Sie die vor installierte APP „Len“ auf dem Tablet-Desktop oder fragen Sie unter dem Link aoacwap.lenovoconnect.com das bestellte Datenpaket ab. Das aktuelle Datenpaket kann nicht bis zum nächsten Monat akkumuliert werden, wenn es nicht verwendet wird.',
    'faq.question.6': 'F2: Ab wann wird das verschenkte Datenpaket in Anwendung gebracht?',
    'faq.answer.6': 'A2: Nachdem Sie sich in der APP „Len“ angemeldet haben, klicken Sie auf das Datenpaket auf der Startseite, um die Berechnung zu aktivieren.',
    'faq.question.7': 'F3: Was sind die Datenpaketbestellregeln?',
    'faq.answer.7': 'A3: Wenn Sie ein neues Datenpaket bestellen, wird es automatisch aktiviert. Wenn Sie ein Überschuss-Datenpaket bestellt haben, wird es aktiviert, wenn der aktuelle Datenverkehr erschöpft ist. Das Datenpaket unterstützt keine Abmeldung oder Aussetzung.',
    'faq.question.8': 'F4: Was ist die Zahlungsweise?',
    'faq.answer.8': 'A4: Es unterstützt Zahlung mit Visa- oder Master-Karte (Pfund, Euro, US-Dollar, Schweizer Franken, Norwegische Krone, Dänische Krone, Schwedische Krone).',
    'faq.question.9': "F5: Das Datenpaket wurde aktiviert/erfolgreich bestellt, kann aber nicht verwendet werden?",
    'faq.answer.9': 'A5: Wenn Sie ein Überschuss-Datenpaket bestellt haben, wird es aktiviert, wenn Ihr vorhandenes Datenpaket erschöpft ist. Wenn Sie ein monatliches Datenpaket bestellt haben, wird das Datenpaket automatisch aktiviert. Der Status kann in meiner Bestellung abgefragt werden. Wenn es sich nicht um die oben genannten Probleme handelt, wenden Sie sich bitte an das Lenovo-Kundendienstteam oder direkt an die E-Mail-Adresse: service@lenovoconnect.com',
    'faq.title.3': 'FAQ-About APP Len',
    'faq.question.10': 'F1: Was soll ich tun, wenn die APP "Len" versehentlich gelöscht oder nicht gefunden wurde?',
    'faq.answer.10': `A1: Bitte unter dem folgenden Link https://aoacupg.lenovoconnect.com/common/downloadLatest laden Sie erneut herunter.`,
    'faq.question.11': "F2: Ich kann mich nicht bei der APP anmelden. Was soll ich tun?",
    'faq.answer.11.1': 'A2:1. Es kann lange dauern, bis sich die APP zum ersten Mal anmeldet, und Sie können etwa eine halbe Minute warten.',
    'faq.answer.11.2': '2. Sie können versuchen, die APP vollständig zu beenden und erneut einzutreten.',
    'faq.answer.11.3': '3. Die APP-Registrierungseite zeigt: Die Mailbox ist bereits vorhanden. Melden Sie sich direkt mit Ihrer Lenovo ID an oder registrieren Sie sich erneut mit Ihrer neuen E-Mail-Adresse.',
    'faq.answer.11.4': '4. Die APP-Anmeldeseite zeigt, dass die Nummern gebunden ist. In diesem Fall haben Sie die Karte an ein E-Mail-Konto gebunden. Wenn Sie Ihre E-Mail-Adresse lösen und neu einrichten müssen, senden Sie bitte eine E-Mail an service@lenovoconnect.com',
    'faq.question.12': 'F3: Was soll ich tun, wenn ich das Passwort für die registrierte Mailbox vergessen habe?',
    'faq.answer.12': 'A3: Sie können auf "Forgot password" unten auf der Anmeldeseite von APP Len klicken, um Ihr Passwort zurückzusetzen.',
    'faq.title.4': 'FAQ-About using data',
    'faq.question.13': "F1: Wie kann ich schließen, wenn ich den Datenverkehr nicht nutzen möchte?",
    'faq.answer.13': 'A1: Wenn Sie den Internetdienst für Datenverkehr deaktivieren möchten, deaktivieren Sie bitte „Mobile data“ in Settings-Network & Internet.“ Das Datenpaket wird nach dem Schließen von „Mobile data“ nicht ausgesetzt oder abgemeldet.',
    'faq.question.14': 'F2: Wie gehe ich damit um, wenn das Internet nicht verfügbar ist?',
    'faq.answer.14.1': 'A2:1. Bitte überprüfen Sie, ob Settings-Network & Internet-Mobile data Schalter eingeschaltet ist',
    'faq.answer.14.2': '2. Bitte überprüfen Sie, ob Settings-Network & Internet-Data Roaming-Schalter eingeschaltet ist (muss eingeschaltet werden, es fallen keine zusätzlichen Roaming-Gebühren an)',
    'faq.answer.14.3': '3. Prüfen Sie, ob Settings-Network & Internet-Advanced-Access Point Names richtig eingerichtet ist, gesetzt werden: lenovo.m2m.drei.at. Wenn Sie diesen APN nicht haben, schreiben Sie ihn bitte manuell hinein.',
    'faq.answer.14.4': '4. Wenn Sie zum ersten Mal eine Verbindung herstellen, kann es einige Minuten dauern.If this your first time to connect, it may take a few minutes.',
    'faq.answer.14.5': '5. Bitte melden Sie sich bei APP Len an und bestätigen Sie, dass das kostenlose Datenpaket aktiviert wurde. Wenn es nicht aktiviert ist, melden Sie sich bitte bei der APP an und klicken Sie auf die Hauptseite, um es zu aktivieren.',
    'faq.answer.14.6': '6. Bitte bestätigen Sie, dass Ihr Standort in den Leistungsumfang fällt (Einzelheiten finden Sie in den folgenden Ländern). Es kann an einen offenen Ort gebracht werden, um das Signal zu empfangen.(Covering all EU countries Austria, Belgium, Bulgaria, Croatia, Cyprus, Czech Republic, Denmark, Estonia, Finland, Frankreich, Germany, Greece, Hungary, Sloland, Italy, Latvia, Lithuania, Luxem bourg, Malta, Netherland pols, Portugal, Roman ania, Schweden, plus Island, Norway, Schweiz, und United Kingdom).',
    'faq.answer.14.7': '7. Überprüfen Sie, ob die SIM-Karte korrekt installiert ist, und starten Sie das Gerät neu.',
    'faq.answer.14.8': '8. Schauen Sie sich Settings-Network & Internet-Automatic ally select network an, um das Netzwerk manuell zu wechseln/auszuwählen. Wenn „forbidden“ angezeigt wird, nachdem ein Netzwerk gefunden wurde, klicken Sie bitte manuell und löschen Sie „forbidden“. Wenn das Klicken auf das Netzwerk nicht funktioniert, legen Sie die SIM-Karte auf das Mobiltelefon um und wiederholen Sie dieselbe Aktion (suchen Sie das mobile Datenverkehrnetzwerk, löschen Sie forbidden von Netzwerk manuell).',
    'faq.question.15': "F3: Wie kann ich die ICCID der SIM-Karte überprüfen?",
    'faq.answer.15.1': 'A3:1. Bitte ziehen Sie die SIM-Karte heraus, die in das Tablet eingelegt ist. Die ICCID befindet sich auf der Karte.',
    'faq.answer.15.2': '2. Bitte überprüfen Sie in APP Len-Me-Device.',
    'faq.answer.15.3': '3. Sie können auf aoacwap.lenovoconnect.com zugreifen und Ihre ICCID auf der Seite ansehen.',
    'faq.question.16': 'F4: Wie beantrage ich eine Rechnung?',
    'faq.answer.16.1': 'A4: Die Rechnung wird automatisch an Ihre registrierte E-Mail-Adresse gesendet, nachdem Sie das Datenpaket erfolgreich bestellt haben. Bitte überprüfen Sie Ihren Posteingang und Ihre Junk-Mail. Wenn Sie es immer noch nicht erhalten haben, wenden Sie sich bitte an den Kundendienst oder senden Sie eine E-Mail an service@lenovoconnect.com',
    'faq.title.5': 'FAQ-About SIM Card',
    'faq.question.17': "F1: Kann ich die ICCID meiner SIM-Karte und meine Lenovo ID nach der Bindung ändern?",
    'faq.answer.17': 'A1: Ja. Bitte wenden Sie sich an das Lenovo Customer Service Center oder senden Sie eine E-Mail an die service@lenovoconnect.com, um die Bindung zu beantragen. Bitte beachten Sie, dass das Abonnementpaket während der Gültigkeitsdauer nicht wegen dem Losbinden ausgesetzt wird.',
    'faq.question.18': 'F2: Was soll ich tun, wenn sich keine Karte im Gerät befindet, die Karten oberfläche offensichtlich beschädigt ist und die Karte verloren geht? Kann ich ein aktiviertes Datenpaket aussetzen?',
    'faq.answer.18': 'A2: Wenn Ihre SIM-Karte beschädigt ist oder verloren geht, wenden Sie sich bitte an das Lenovo Customer Service Center oder an die E-Mail-service@lenovoconnect.com. Nach der Überprüfung gegen spezifische Situation wird Ihnen eine neue gesendet. Das Aussetzen oder Abbestellen wird bei aktivierten Datenpaketen nicht unterstützt.',
}
// 接口返回错误码
const iCode = {
    'iCode.i0001': 'Kennwortfehler',
    'iCode.i0002': 'Diese E-Mail ist schon vorhanden',
    'iCode.i0003': 'Kennwortformatfehler',
    'iCode.i0004': 'Konto muss vor dem Login aktiviert werden.',
    'iCode.i0005': 'Konto ist deaktiviert',
    'iCode.i0006': 'Login-Timeout',
    'iCode.i0007': 'fehler',
    'iCode.i0008': 'Falsches Konto oder Passwort',
    'iCode.i0009': 'Bitte geben Sie 5-stelligen grafischen Captcha ein',
    'iCode.i0010': 'Der Betrieb ist zu häufig. Bitte versuchen Sie es später erneut.',
    'iCode.i0011': 'Ungültige Rückrufadresse.',
    'iCode.i0012': 'Ungültige Unterschrift.',
    'iCode.i0013': 'Bitte aktualisieren Sie den Captcha',
    'iCode.i0014': 'Serverfehler',
    'iCode.i0015': 'Service Good ID ist leer',
    'iCode.i0016': 'Nachricht erfolgreich gesendet',
    'iCode.i0017': 'Fehler beim Senden von Nachrichten',
    'iCode.i0018': 'falscher Einlösecode',
    'iCode.i0019': 'Bitte in der Einlöseperiode anwenden',
    'iCode.i0020': 'Einlösecode abgelaufen',
    'iCode.i0021': 'Einlösecode angewendet',
    'iCode.i0022': 'Einlösecode ungültig',
    'iCode.i0023': 'Bestellung wird erstellt, bitte warten Sie...',
    'iCode.i0024': 'Operatoin gelungen',
    'iCode.i0025': 'Kartennummer entspricht nicht der Einlösebedingung',
    'iCode.i0026': 'QR code generation failed',
    'iCode.i0027': 'Informationsfehler beim Erstellen einer Upgrade-Bestellung',
    'iCode.i0028': 'SIM existiert nicht',
    'iCode.i0029': 'Handynummernformat Fehler',
    'iCode.i0030': 'SMS-Versand zu häufig',
    'iCode.i0031': 'Parameterfehler',
    'iCode.i0032': 'Die Anzahl der Sendung des Captchas innerhalb eines Tages hat die Obergrenze erreicht',
    'iCode.i0033': 'Konto erfolgreich angemeldet',
    'iCode.i0034': 'Kontoregistrierung fehlgeschlagen',
    'iCode.i0035': 'Bitte binden Sie zuerst SIM ICCID',
    'iCode.i0036': 'Bitte melden Sie sich zuerst im Konto an',
    'iCode.i0037': 'Statusaktualisierung fehlgeschlagen',
    'iCode.i0038': 'Aktivieren, bitte warten Sie',
    'iCode.i0039': 'Order-ID ist leer',
    'iCode.i0040': 'Aktivierung läuft, bitte warten Sie',
    'iCode.i0041': 'Paket ist aus dem Regal',
    'iCode.i0042': 'Die Aktivierung ist fehlgeschlagen',
    'iCode.i0043': 'Die Aktivierung ist erfolgreich',
    'iCode.i0044': 'Das System kann SIM nicht identifizieren',
    'iCode.i0045': 'Paket aktiviert, nicht wiederholen',
    'iCode.i0046': 'Keine aktivierten Pakete',
    'iCode.i0047': 'gesperrt',
    'iCode.i0048': 'Falsche Paketinformationen',
    'iCode.i0049': 'Benutzer oder Passwort ist leer',
    'iCode.i0050': 'Kein Basispaket für den Monat',
    'iCode.i0051': 'Sie haben sich erfolgreich angemeldet',
    'iCode.i0052': 'Abnormale Anmeldung',
    'iCode.i0053': 'Gerät ist leer',
    'iCode.i0054': 'Captchafehler, bitte erneut eingeben',
    'iCode.i0055': 'Erfolgreicher Betrieb',
    'iCode.i0056': 'SIM ist leer',
    'iCode.i0057': 'Erhalten von Token fehlgeschlagen',
    'iCode.i0058': 'Unternehmenscode ist nicht vorhanden',
    'iCode.i0059': 'Die Verwendung von SIM steht im Widerspruch zu den Unternehmenseigenschaften',
    'iCode.i0060': 'Bitte betreiben Sie nicht häufig',
    'iCode.i0061': 'Gutschein erfolgreich erhalten',
    'iCode.i0062': 'Die Bedingungen für den Erhalt des Gutscheins sind nicht erfüllt ',
    'iCode.i0063': 'Fehlerhaft beim Erhalt des Kupons',
    'iCode.i0064': 'Iccid-Bindung fehlgeschlagen',
    'iCode.i0065': 'Die Karte ist durch ein anderes Konto gebunden',
    'iCode.i0066': 'Bindung erfolgreich',
    'iCode.i0067': 'Bindungsfehler',
    'iCode.i0068': 'SIM-ID ist leer',
    'iCode.i0069': 'eSIM-ID ist leer',
    'iCode.i0070': 'Keine SIM-Bindung',
    'iCode.i0071': 'Benutzer ist nicht vorhanden',
    'iCode.i0072': 'Nickname sollte nicht leer sein',
    'iCode.i0073': 'Erfolgreich aktualisiert',
    'iCode.i0074': 'Aktualisierung fehlgeschlagen',
    'iCode.i0075': 'Homepage keine Abfrage nach dem abnormalen SIM Paket',
    'iCode.i0076': 'Relevante Informationen nicht verfügbar',
    'iCode.i0077': 'Generieren verschlüsselter Unterzeichnung ungelungen.',
    'iCode.i0078': 'Wechsel gelungen',
    'iCode.i0079': 'Wechsel erfolgreich',
    'iCode.i0080': 'Bitte reichen Sie die Anträge nicht wiederholt ein',
    'iCode.i0081': 'Bitte aktualisieren Sie und betreiben Sie erneut!',
    'iCode.i0082': 'Erhalten vom Banner-Diagramm der Homepage fehlgeschlagen',
    'iCode.i0083': 'Derzeit keine gebundene ICCID, kein Präferenzpaket',
    'iCode.i0084': 'Derzeit kein gebundenes ICCID, kein verfügbares Paket',
    'iCode.i0085': 'Erfolgreiche Authentifizierung',
    'iCode.i0086': 'Authentifizierung fehlgeschlagen',
    'iCode.i0087': 'Systemanomalie',
    'iCode.i0088': 'SIM mit echtem Namen authentifiziert',
    'iCode.i0089': 'Der Plan wurde erfolgreich bestellt',
    'iCode.i0090': 'Plan-Bestellen fehlgeschlagen',
    'iCode.i0091': 'Serviceprodukt ist nicht vorhanden',
    'iCode.i0092': 'Upgrade-Service-Bestellung generiert',
    'iCode.i0093': 'Kein Upgrade-Paket-Service',
    'iCode.i0094': 'Keine entsprechende Bestellung gefunden',
    'iCode.i0095': 'Aktuelles Paket wird nicht bezahlt',
    'iCode.i0096': 'Paket-ID in der Bestellung ist leer',
    'iCode.i0097': 'Paket bereits aktiviert',
    'iCode.i0098': 'Erfolgreiche Bestellung',
    'iCode.i0099': 'keine Nummer vorläufig verfügbar',
    'iCode.i0100': 'keine Nummer von dieser Region',
    'iCode.i0104': 'UErhalten der Sub-Region der SIM-Karte fehlgeschlagen',
    'iCode.i0109': 'Es ist nicht gelungen, Barcode zu lesen, bitte laden Sie noch einmal hoch.',
}
export default {
    ...common,
    ...language,
    ...login,
    ...register,
    ...home,
    ...me,
    ...packageCard,
    ...packageDetail,
    ...billAddress,
    ...order,
    ...accountInfo,
    ...device,
    ...myDataPlan,
    ...FAQ,
    ...iCode,
    ...payResult,
    ...Contact,
    ...bindSim,
    ...suggest,
    ...faqApp,
    'tab.text.home': 'Startseite',
    'tab.text.me': 'Mich'
}
